import React from 'react'
import classNames from 'classnames'

interface SuggestedContentCardPlaceholderProps {
  className?: string
}

// Skeleton placeholder matching SuggestedContentCard layout
export const SuggestedContentCardPlaceholder: React.VFC<SuggestedContentCardPlaceholderProps> = (props) => {
  return (
    <div
      data-testid="empty-suggested-content-card"
      className={classNames('relative min-w-[250px] pr-6 lg:min-w-[316px]', props.className)}
    >
      <div className="flex flex-col">
        {/* Thumbnail placeholder: 2:3 aspect ratio */}
        <div className="aspect-h-3 aspect-w-2 relative mb-3 w-full animate-pulse overflow-hidden rounded-2xl bg-core-gray-800">
          <div className="absolute inset-0 bg-core-gray-700" />
        </div>

        <div className="flex flex-col gap-y-1">
          {/* Type badge (Series/Movie/Special) */}
          <div className="h-4 w-20 animate-pulse rounded bg-core-gray-700" />
          {/* Title */}
          <div className="h-6 w-3/4 animate-pulse rounded bg-core-gray-700" />
          {/* Guild score chip */}
          <div className="mt-1 h-6 w-24 animate-pulse rounded-full bg-core-gray-700" />
        </div>
      </div>
    </div>
  )
}
